import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const FindTheMissingNumber = () => {
  const numbers = [10, 20, 30, 40, 50, 60, 70, 80, 90];
  const [currentNumber, setCurrentNumber] = useState(0);
  const [userInput, setUserInput] = useState('');
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('#006064');
  const [progress, setProgress] = useState(0);

  const inputRef = useRef(null);
  const maxProgress = 100;

  const generateQuestion = () => {
    const randomIndex = Math.floor(Math.random() * numbers.length);
    setCurrentNumber(numbers[randomIndex]);
    setUserInput('');
    setFeedback('');
    setFeedbackColor('#006064');
    inputRef.current?.focus();
  };

  const checkAnswer = () => {
    const answer = parseInt(userInput.trim(), 10);
    if (isNaN(answer)) {
      setFeedback('Please enter a number!');
      setFeedbackColor('#d32f2f');
      return;
    }

    const correctAnswer = 100 - currentNumber;

    if (answer === correctAnswer) {
      setFeedback('🎉 Awesome! That’s correct!');
      setFeedbackColor('#388e3c');

      const newProgress = Math.min(progress + 20, maxProgress);
      setProgress(newProgress);

      if (newProgress === maxProgress) {
        setFeedback("🎊 You filled the progress meter! Great job! 🎊");
              const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
        
      } else {
        setTimeout(generateQuestion, 1500);
      }
    } else {
      setFeedback('❌ Not quite. Try again!');
      setFeedbackColor('#d32f2f');
      inputRef.current?.focus();
    }
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      checkAnswer();
    }
  };

  const styles = {
    wrapper: {
      fontFamily: "'Comic Sans MS', cursive",
      background: '#e0f7fa',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '2rem',
      boxSizing: 'border-box',
    },
    container: {
      background: '#ffffff',
      padding: '2rem',
      borderRadius: '20px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      width: '100%',
      maxWidth: '450px',
      textAlign: 'center',
    },
    heading: {
      fontSize: '1.8rem',
      marginBottom: '0.5rem',
      color: '#00838f',
    },
    question: {
      fontSize: '1.4rem',
      margin: '1rem 0',
      color: '#006064',
    },
    input: {
      fontSize: '1.1rem',
      padding: '0.6rem',
      width: '100%',
      maxWidth: '180px',
      textAlign: 'center',
      margin: '1rem auto',
      borderRadius: '10px',
      border: '2px solid #ff69b4',
      display: 'block',
    },
    button: {
      fontSize: '1.1rem',
      padding: '0.7rem 1.4rem',
      background: '#00838f',
      color: '#ffffff',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      marginTop: '0.5rem',
    },
    feedback: {
      fontSize: '1.2rem',
      marginTop: '1rem',
      minHeight: '2rem',
    },
    progressContainer: {
      width: '100%',
      maxWidth: '300px',
      height: '24px',
      background: '#b2ebf2',
      borderRadius: '15px',
      margin: '2rem auto 1rem',
      overflow: 'hidden',
      boxShadow: 'inset 0 0 5px #4dd0e1',
    },
    progressBar: {
      height: '100%',
      width: `${progress}%`,
      background: '#00838f',
      transition: 'width 0.5s ease-in-out',
    },
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h2 style={styles.heading}>Find the Missing Number</h2>
        <div style={styles.question}>
          What number do we add to {currentNumber} to make 100?
        </div>
        <input
          type="number"
          placeholder="Your answer"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          onKeyDown={handleKeyDown}
          style={styles.input}
          disabled={progress === maxProgress}
          ref={inputRef}
        />
        <button
          onClick={checkAnswer}
          style={styles.button}
          disabled={progress === maxProgress}
        >
          Submit
        </button>
        <div style={{ ...styles.feedback, color: feedbackColor }}>{feedback}</div>

        <div style={styles.progressContainer}>
          <div style={styles.progressBar}></div>
        </div>
      </div>
    </div>
  );
};

export default FindTheMissingNumber;
